import React, { useEffect } from "react";
import { AnimationFadeToggle } from "../../utils";

const ModalCertificate = ({ data, onCloseModal, status }) => {
    //Habilitar y deshabilitar scroll
    useEffect(() => {
        if (data) {
            document.body.style.overflow = "hidden";
            return () => {
                document.body.style.overflow = null;
            };
        }
    }, [data]);

    return (
        <AnimationFadeToggle isOpen={data}>
            <section className='modal modal-fleet-certificate'>
                <div className='main-container'>
                    <div className='modal-box'>
                        <div
                            className='close-button icon close'
                            id='close-modal'
                            onClick={onCloseModal}></div>
                        <div className='modal-body'>
                            {status == "success" && (
                                <div>
                                    <p className='modal-title'>
                                        Descarga el Certificado de tu Vehículo
                                    </p>

                                    <p>Vin {data.vin && data.vin}</p>
                                </div>
                            )}
                            {status == "error" && (
                                // ERROR
                                <div>
                                    <p className='modal-title'>Ups!</p>

                                    <p>
                                        El VIN ingresado no existe en nuestros
                                        registros. Por favor revise los datos y
                                        vuelva a intentarlo.
                                    </p>
                                </div>
                            )}

                            {status == "success" && (
                                <a
                                    className='btn black'
                                    id='download-fleet'
                                    href={data.url}
                                    target='_blank'>
                                    Descargar ahora
                                </a>
                            )}
                            {status == "error" && (
                                // ERROR
                                <button
                                    className='btn black'
                                    onClick={onCloseModal}>
                                    Volver
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </AnimationFadeToggle>
    );
};

export default ModalCertificate;
